<template>
  <tr :class="itemData.color">
    <td>{{ itemData.contragent }}</td>
    <td>{{ itemData.obj }}</td>
    <td>{{ itemData.docSumVisible }}</td>
    <td>{{ itemData.januaryVisible }}</td>
    <td>{{ itemData.februaryVisible }}</td>
    <td>{{ itemData.marthVisible }}</td>
    <td>{{ itemData.aprilVisible }}</td>
    <td>{{ itemData.mayVisible }}</td>
    <td>{{ itemData.juneVisible }}</td>
    <td>{{ itemData.juleVisible }}</td>
    <td>{{ itemData.augustVisible }}</td>
    <td>{{ itemData.septemberVisible }}</td>
    <td>{{ itemData.octoberVisible }}</td>
    <td>{{ itemData.novemberVisible }}</td>
    <td>{{ itemData.decemberVisible }}</td>
    <td>{{ itemData.totalVisible }}</td>
    <td>{{ itemData.totalVisible }}</td>
  </tr>
</template>

<script>
export default {
  name: "StringTable",
  props:{
    itemData: Object
  },
}
</script>

<style scoped>

</style>